import { render, staticRenderFns } from "./EventSelectorV3.vue?vue&type=template&id=3935fc17&scoped=true&"
import script from "./EventSelectorV3.vue?vue&type=script&lang=js&"
export * from "./EventSelectorV3.vue?vue&type=script&lang=js&"
import style0 from "./EventSelectorV3.vue?vue&type=style&index=0&id=3935fc17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935fc17",
  null
  
)

export default component.exports